/**
 * Kto odišiel od stola (online hra) — ako v Karaku. Server posiela v pohľade
 * `online`: miesta, ktorých hráč má stôl otvorený (boti vždy; odpojený sa ráta
 * ešte 5 s, nech refresh nebliká). V strede dosky visí „X nie je pri stole",
 * pri návrate na chvíľu „X je späť pri stole".
 */

import { content } from '@unmatched/content';
import { useEffect, useMemo, useRef, useState } from 'react';

import type { MatchView } from '../api.js';

export function AwayNotice({ view }: { view: MatchView }) {
  const away = useMemo(() => {
    if (view.mode !== 'online' || !view.state || view.state.phase === 'ended' || !view.online) return [];
    return view.seats
      .filter((s) => !s.isBot && !s.isYou && !s.eliminated && !view.online!.includes(s.slot))
      .map((s) => s.slot);
  }, [view]);

  const previous = useRef<number[]>([]);
  const [back, setBack] = useState<number | null>(null);
  useEffect(() => {
    const returned = previous.current.find((slot) => !away.includes(slot));
    previous.current = away;
    if (returned === undefined) return;
    setBack(returned);
    const timer = window.setTimeout(() => setBack(null), 3500);
    return () => window.clearTimeout(timer);
  }, [away]);

  const seat = (slot: number) => view.seats.find((s) => s.slot === slot);
  const hero = (slot: number) => {
    const id = seat(slot)?.heroId;
    return id ? (content.heroes[id]?.name ?? id) : '?';
  };

  return (
    <>
      {away.length > 0 ? (
        <div className="awayNotice" role="status">
          <span className="awayNotice__icon" aria-hidden="true">
            ⏻
          </span>
          {away.map((slot) => (
            <p key={slot} className="awayNotice__who">
              <b>{seat(slot)?.nick ?? '?'}</b> ({hero(slot)}) nie je pri stole
            </p>
          ))}
          <p className="awayNotice__hint">
            {view.activeSlot !== null && away.includes(view.activeSlot)
              ? 'Hra čaká, kým sa vráti.'
              : 'Spojenie sa prerušilo. Hrá sa ďalej, kým nepríde na rad.'}
          </p>
        </div>
      ) : null}
      {back !== null && !away.includes(back) ? (
        <div className="awayBack" role="status">
          <b>{seat(back)?.nick ?? '?'}</b> je späť pri stole
        </div>
      ) : null}
    </>
  );
}
